import React, { useEffect, useState } from "react";
import { useFetchCurrentOrdersQuery } from "../../Apis/ordersApi";
import OrdersListContainer from "./OrdersList";
import OrdersCarriersMap from "./OrdersCarriersMap";
import OrderDetailModal from "./OrderDetailModal";
import { LeftCollapsibleIcon } from "../Icons/collapsible-icons";
import styles from "./orders.module.css";

export const ORDERS_COMPONENT = "ORDERS_COMPONENT";

const OrdersWrapper = () => {
  const [page, setPage] = useState(1);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [statusFilters, setStatusFilters] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({
    orderId: null,
    companyId: null,
  });
  const { data, isFetching, error, isSuccess } = useFetchCurrentOrdersQuery({
    page,
    companyIds: companies,
    status: statusFilters,
  });

  useEffect(() => {
    setPage(1);
  }, [companies, statusFilters]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleOrderClick = (orderId, companyId) => {
    setSelectedOrder({
      orderId,
      companyId,
    });
  };

  const handleCloseModal = () => {
    setSelectedOrder({
      orderId: null,
      companyId: null,
    });
  };

  return (
    <div className={styles.wrapperContainer}>
      <div style={{ display: 'flex', width: '100%', height: '100%' }}>
        {!isCollapsed && (
          <OrdersListContainer
            data={data}
            isLoading={isFetching}
            error={error}
            isSuccess={isSuccess}
            page={page}
            onPageChange={setPage}
            onOrderClick={handleOrderClick}
            companies={companies}
            setCompanies={setCompanies}
            statusFilters={statusFilters}
            setStatusFilters={setStatusFilters}
          />
        )}
        <OrdersCarriersMap ordersData={data} onOrderClick={handleOrderClick} />
      </div>
      <div className={styles.collapseButton} onClick={toggleCollapse}>
        <LeftCollapsibleIcon />
      </div>
      <OrderDetailModal
        orderId={selectedOrder.orderId}
        companyId={selectedOrder.companyId}
        open={!!selectedOrder.orderId && !!selectedOrder.companyId}
        onClose={handleCloseModal}
      />
    </div>
  );
};

export default OrdersWrapper;
